export default __webpack_public_path__ + "b406e0c0aeb4381acfc326a1c49d44c5.svg";